import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromLetterUpload from '../../reducers/letter-upload/letter-upload.reducer';

export const selectLetterUploadState = createSelector(
  fromFeature.getLetterUploadState,
  (state) => state,
);
export const selectLetterFilesMetadata = createSelector(
  fromFeature.getLetterUploadState,
  (state) => {
    return state.filesMetaData;
  },
);
export const selectIsLetterInState = createSelector(
  selectLetterUploadState,
  fromLetterUpload.getHasClientUploadedFile,
);
export const selectVGHasLetter = createSelector(
  fromFeature.getLetterUploadState,
  (state) => state.vgHasLetter,
);
